import { SplitterPaneProps } from "@progress/kendo-react-layout";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { insertElement, setSelectedRoute } from "./editorSlice";

type InitialState = {
  isDrawerOpen: boolean;
  panes: Array<SplitterPaneProps>;
};

const DRAWER_MIN_SIZE: string = "80px";
const DRAWER_DEFAULT_SIZE: string = "25%";

const initialState: InitialState = {
  isDrawerOpen: false,
  panes: [
    // Insertion Drawer Pane
    {
      resizable: false,
      collapsible: false,
      scrollable: false,
    },
    // Form Pane
    {},
    // Properties Pane
    {
      size: DRAWER_MIN_SIZE,
      min: DRAWER_MIN_SIZE,
      max: "30%",
      resizable: false,
    },
  ],
};

const PANEL_INDEX: number = 2;

export const visualEditorSlice = createSlice({
  name: "VisualEditor",
  initialState,
  reducers: {
    setPanes(state, action: PayloadAction<Array<any>>) {
      state.panes = action.payload;
    },
    setIsDrawerOpen: (state, action: PayloadAction<boolean>): void => {
      const isOpen = action.payload;

      if (!isOpen) {
        state.panes[PANEL_INDEX].size = initialState.panes[1].min;
        state.panes[PANEL_INDEX].resizable = false;
      } else {
        state.panes[PANEL_INDEX].size = DRAWER_DEFAULT_SIZE;
        state.panes[PANEL_INDEX].min = "250px";
        state.panes[PANEL_INDEX].max = initialState.panes[1].max;
        state.panes[PANEL_INDEX].resizable = true;
      }

      state.isDrawerOpen = isOpen;
    },
  },
  extraReducers: {
    [setSelectedRoute.type]: (state, action) => {
      if (action.payload) {
        state.panes[PANEL_INDEX].size = DRAWER_DEFAULT_SIZE;
        state.isDrawerOpen = true;
        state.panes[PANEL_INDEX].min = "250px";
        state.panes[PANEL_INDEX].max = initialState.panes[PANEL_INDEX].max;
        state.panes[PANEL_INDEX].resizable = true;
      }
    },
    [insertElement.type]: (state) => {
      state.panes[PANEL_INDEX].size = DRAWER_DEFAULT_SIZE;
      state.isDrawerOpen = true;
      state.panes[PANEL_INDEX].min = "250px";
      state.panes[PANEL_INDEX].max = initialState.panes[PANEL_INDEX].max;
      state.panes[PANEL_INDEX].resizable = true;
    },
  },
});

export const { setPanes, setIsDrawerOpen } = visualEditorSlice.actions;
